function optionChange(e) {}

function quickView(e) {
    0 == $("#quick-view").length && ($("body").append('<div id="quick-view"></div>'), $("body").addClass("quick-view_popup"));
    var t = e;
    $("#quick-view").addClass(t), jQuery.getJSON("/products/" + t + ".js", function(e) {
        (t => {
            let i = `/products/${t}`;
            return fetch(i).then(e => e.text()).then(t => {
                let i = new DOMParser,
                    o = i.parseFromString(t, "text/html"),
                    r = o.documentElement.querySelector(".quick-add-product");
                $("#quick-view .new_product").append(r), $('#product_popup').detach();  $('#quick-view .slider-buttons').detach();  $('.new_product .product_pickup').detach(); $('.new_product product-recommendations').detach(); $("#quick-view .shopify-payment-button").detach(), setTimeout(function() {
                    $(".breadcrumb").remove(), $("#quick-view modal-opener").remove();
                    $(".loader").hide();
                }, 100)
            })
        })(t)
    }), $.fancybox({
        href: "#quick-view",
        maxWidth: 1040,
        maxHeight: 650,
        overlay: {
            locked: !1
        },
        fitToView: !0,
        width: "100%",
        height: "100%",
        autoSize: !1,
        openSpeed: 200,
        closeSpeed: 200,
        closeClick: !1,
        changeFade: "fast",
        openEffect: "elastic",
        closeEffect: "elastic",
        afterShow: function() {
            $("#quick-view").hide().html(content).css("opacity", "1").fadeIn();
          $("body").addClass("quick-view_popup");
        },
        afterClose: function() {
            $("#quick-view").removeClass().empty(), $("body").removeClass("quick-view_popup");
        }
    })
}
$(document).ready(function() {
    $.getScript("//cdn.shopify.com/s/files/1/0608/4522/8089/t/14/assets/quick-add-box.js").done(function() {})
});